/* eslint-disable no-undef */

import D365WebTracking from '/Integrations/Dynamics365/js/d365-web-tracking.js';

/**
 * OneTrust groups
 * @constant {string} C0001 - Strictly Necessary Cookies
 * @constant {string} C0002 - Performance Cookies
 * @constant {string} C0003 - Functional Cookies
 * @constant {string} C0004 - Targeting Cookies
 * @constant {string} C0005 - Social Media Cookies
 *
 * CookieBot groups
 * Cookie name = CookieConsent
 * necessary (strictly necessary))
 * preferences (functional)
 * statistics (performance)
 * marketing (targeting)
 *
 * console.log(document.cookie.split('; ').find(row => row.startsWith('CookieConsent=')));
 *
 * Cookie example
 * {stamp:%27mZuPtb9QOnYwd8NfK4V+yNcvRL11mMWdhKzNfQfeSLFOAuxlt/B86w==%27%2Cnecessary:true%2Cpreferences:true%2Cstatistics:true%2Cmarketing:true%2Cmethod:%27explicit%27%2Cver:1%2Cutc:1785519529439%2Cregion:%27us-50%27}
 */

class CookieConsent {
  // ========================================
  // COOKIE HELPERS
  // ========================================

  getCookieValue(name) {
    const row = document.cookie.split('; ').find((entry) => entry.startsWith(`${name}=`));

    return row ? decodeURIComponent(row.substring(name.length + 1)) : null;
  }

  isCookiebotCategoryActive(cookiebotCookie, category) {
    const match = cookiebotCookie.match(new RegExp(`${category}:(true|false)`));

    return match ? match[1] === 'true' : false;
  }

  isStatisticsConsentActive() {
    const cookiebotCookie = this.getCookieValue('CookieConsent');

    if (cookiebotCookie) {
      return this.isCookiebotCategoryActive(cookiebotCookie, 'statistics');
    }

    const activeGroups = window.OnetrustActiveGroups;

    return activeGroups ? activeGroups.includes('C0002') : false;
  }

  // ========================================
  // VIDYARD
  // ========================================

  updateVidyardConsent() {
    return new Promise(() => {
      const checkVidyardEmbed = () => {
        if (typeof VidyardV4 !== 'undefined') {
          if (this.isStatisticsConsentActive()) {
            this.grantVidyardConsent();
          } else {
            this.revokeVidyardConsent();
          }
        } else {
          setTimeout(checkVidyardEmbed, 100);
        }
      };

      checkVidyardEmbed();
    });
  }

  revokeVidyardConsent() {
    if (typeof VidyardV4 !== 'undefined') {
      VidyardV4.api.GDPR.consent(false);
    }
  }

  grantVidyardConsent() {
    if (typeof VidyardV4 !== 'undefined') {
      VidyardV4.api.GDPR.consent(true);
    }
  }

  // ========================================
  // DYNAMICS 365 WEB TRACKING
  // ========================================

  initD365WebTracking() {
    if (this.isStatisticsConsentActive()) {
      const d365WebTracking = new D365WebTracking();

      d365WebTracking.init();
    }
  }
}

const cookieConsent = new CookieConsent();

window.addEventListener(
  'CookiebotOnConsentReady',
  () => {
    cookieConsent.initD365WebTracking();
    cookieConsent.updateVidyardConsent();
  },
  { once: true },
);

// window.addEventListener('CookiebotOnAccept', () => {
//   if (window.location.href.includes('policies/privacy')) {
//     window.location.reload();
//   }
// });
